import { api_url } from "./constant";
import { getLocalStorage } from "./util-service";
import axios from "axios";
let authToken;

function getAuthDetails() {
  authToken = getLocalStorage("authToken");
}

export const postCreateVendor = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.post(`${api_url}/admin/add-vendor`, obj, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const putCreateVendor = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.put(`${api_url}/admin/update-vendor`, obj, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getVendors = async () => {
  getAuthDetails();
  try {
    const response = await axios.get(`${api_url}/admin/vendors`, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getVendorByVendorID = async (vendorID) => {
  getAuthDetails();
  try {
    const response = await axios.get(`${api_url}/admin/vendor/${vendorID}`, {
      headers: {
        "x-access-token": authToken,
      },
    });
    if (response.status === 200) return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};
// Customer Section

export const postCreateCustomerForVendor = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.post(
      `${api_url}/admin/vendor/create-user`,
      obj,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const putUpdateCustomerForVendor = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.put(
      `${api_url}/admin/vendor/update-user`,
      obj,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const deleteCustomerForVendor = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.put(
      `${api_url}/admin/vendor/delete-user`,
      obj,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getCustomersByVendorID = async (vendorID) => {
  getAuthDetails();
  try {
    const response = await axios.get(`${api_url}/admin/customers/${vendorID}`, {
      headers: {
        "x-access-token": authToken,
      },
    });
    if (response.status === 200) return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};
// Estimates API's
export const getPaginatedEstimates = async (
  limit = "25",
  offset = "0",
  status = "NEW",
) => {
  getAuthDetails();
  try {
    const response = await axios.get(
      `${api_url}/admin/estimates?limit=${limit}&offset=${offset}&status=${status}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getEstimateByEstimateID = async (estimateId) => {
  getAuthDetails();
  try {
    const response = await axios.get(
      `${api_url}/admin/estimate/${estimateId}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    if (response.status === 200) return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const updateEstimateByEstimateID = async (estimateId, obj) => {
  getAuthDetails();
  try {
    const response = await axios.put(
      `${api_url}/admin/estimate/${estimateId}`,
      obj,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    if (response.status === 204) return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const bulkUpdateEstimateStatus = async (estimateIds, status) => {
  getAuthDetails();
  try {
    const response = await axios.put(
      `${api_url}/admin/estimates/bulk-status`,
      { estimateIds, status },
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    if (response.status === 200) return response;
  } catch (error) {
    console.error("Error bulk updating estimate status:", error);
    return error;
  }
};

export const deleteEstimateByEstimateID = async (estimateId) => {
  getAuthDetails();
  try {
    const response = await axios.delete(
      `${api_url}/admin/delete-estimate/${estimateId}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    if (response.status === 204) return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getSearchProduct = async (text) => {
  getAuthDetails();
  try {
    const response = await axios.get(
      `${api_url}/admin/search?searchText=${text}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
  }
};

export const getProductById = async (id) => {
  getAuthDetails();
  try {
    const response = await axios.get(`${api_url}/admin/product?id=${id}`, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
  }
};

export const postProductToEstimateAgain = async (obj) => {
  getAuthDetails();
  try {
    const response = await axios.post(`${api_url}/admin/estimate-again`, obj, {
      headers: {
        "x-access-token": authToken,
      },
    });
    if (response.status === 200) return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

// Banner Settings

export const postBanner = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.post(`${api_url}/admin/add-banner`, obj, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const putUpdateBanner = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.put(`${api_url}/admin/update-banner`, obj, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const putReorderBanners = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.put(`${api_url}/admin/reorder-banners`, obj, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const getBanners = async (type = "PRIMARY") => {
  getAuthDetails();
  try {
    const response = await axios.get(`${api_url}/admin/banners`, {
      params: { type },
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

export const deleteBannerById = async (obj) => {
  const authToken = getLocalStorage("authToken");
  try {
    const response = await axios.put(`${api_url}/admin/delete-banner`, obj, {
      headers: {
        "x-access-token": authToken,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending data:", error);
    return error;
  }
};

// Vendor Wishlist
export const getVendorWishlist = async (vendorID, limit = 20, offset = 0) => {
  getAuthDetails();
  try {
    const response = await axios.get(
      `${api_url}/admin/wishlist/${vendorID}?limit=${limit}&offset=${offset}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error fetching vendor wishlist:", error);
    return error;
  }
};

export const removeVendorWishlistItem = async (vendorID, shopifyProductId) => {
  getAuthDetails();
  try {
    const response = await axios.delete(
      `${api_url}/admin/wishlist/${vendorID}`,
      {
        headers: {
          "x-access-token": authToken,
        },
        data: { shopifyProductId },
      },
    );
    return response;
  } catch (error) {
    console.error("Error removing vendor wishlist item:", error);
    return error;
  }
};

export const addVendorWishlistItem = async (vendorID, payload) => {
  getAuthDetails();
  try {
    const response = await axios.post(
      `${api_url}/admin/wishlist/${vendorID}`,
      payload,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error adding vendor wishlist item:", error);
    return error;
  }
};

// Store Management — Out of Stock (cursor pagination + optional title search)
export const getOutOfStockProducts = async (
  limit = 20,
  cursor = null,
  title = null
) => {
  getAuthDetails();
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) {
      params.set("cursor", cursor);
    }
    if (title != null && String(title).trim() !== "") {
      params.set("title", String(title).trim());
    }
    const response = await axios.get(
      `${api_url}/admin/products/out-of-stock?${params.toString()}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error fetching out-of-stock products:", error);
    return error;
  }
};

// Store Management — Draft products (cursor pagination)
export const getDraftProducts = async (limit = 20, cursor = null) => {
  getAuthDetails();
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) {
      params.set("cursor", cursor);
    }
    const response = await axios.get(
      `${api_url}/admin/products/draft?${params.toString()}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error fetching draft products:", error);
    return error;
  }
};

// Store Management — Active (published) collections (cursor pagination)
export const getActiveCollections = async (limit = 20, cursor = null) => {
  getAuthDetails();
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) {
      params.set("cursor", cursor);
    }
    const response = await axios.get(
      `${api_url}/admin/collections/active?${params.toString()}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error fetching active collections:", error);
    return error;
  }
};

// Store Management — Unpublished collections (cursor pagination)
export const getUnpublishedCollections = async (limit = 20, cursor = null) => {
  getAuthDetails();
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) {
      params.set("cursor", cursor);
    }
    const response = await axios.get(
      `${api_url}/admin/collections/unpublished?${params.toString()}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching unpublished collections:", error);
    return error;
  }
};

// Store Management — Products in a collection (cursor pagination)
export const getCollectionProducts = async (
  collectionId,
  limit = 20,
  cursor = null
) => {
  getAuthDetails();
  try {
    const id = encodeURIComponent(String(collectionId));
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) {
      params.set("cursor", cursor);
    }
    const response = await axios.get(
      `${api_url}/admin/collections/${id}/products?${params.toString()}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching collection products:", error);
    return error;
  }
};

// Store Management — Inquired products (offset pagination)
// V2 filter hooks: vendorID, minCount, days (passed through when provided)
export const getInquiredProducts = async (
  limit = 20,
  offset = 0,
  filters = {},
) => {
  getAuthDetails();
  try {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
    });
    if (filters.vendorID) {
      params.set("vendorID", String(filters.vendorID));
    }
    if (filters.minCount != null && filters.minCount !== "") {
      params.set("minCount", String(filters.minCount));
    }
    if (filters.days === null || filters.days === "all") {
      params.set("days", "all");
    } else if (filters.days != null && filters.days !== "") {
      params.set("days", String(filters.days));
    }
    const response = await axios.get(
      `${api_url}/admin/products/inquired?${params.toString()}`,
      {
        headers: {
          "x-access-token": authToken,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error fetching inquired products:", error);
    return error;
  }
};
